var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-header-data"},[[_c('font-awesome-icon',{attrs:{"icon":['fab', _vm.integration]}}),_vm._v("\n        "+_vm._s(_vm.integration)+"\n\n    ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }